import { toGalleryView } from "@ext/markdown/elements/gallery/model/gallery";
import { type Schema, SchemaType, Tag } from "../../../../core/render/logic/Markdoc/index";

export const gallery: Schema = {
	render: "gallery",
	attributes: {
		view: { type: String },
		title: { type: String },
		scale: { type: String },
	},
	selfClosing: false,
	type: SchemaType.block,
	transform: async (node, config) => {
		const attributes = { ...node.attributes, view: toGalleryView(node.attributes.view) };
		return new Tag("gallery", attributes, await node.transformChildren(config));
	},
};
